import { FilterOperator, LogicalOperator } from './types';

const escapeFilterString = (filterString: string): string => {
  // Replace all singlequotes to double singlequotes because
  // viya services treat double singlequotes as single singlequotes
  return filterString.replace(/'/g, "''");
};

export const getFilterExpression = (
  filterOperator: FilterOperator,
  filterKey: string,
  ...filterValues: string[]
): string => {
  const escapedFilterKey = escapeFilterString(filterKey);
  const escapedFilterValues = filterValues
    .map((filterValue) => escapeFilterString(filterValue))
    .join("','");

  return `${filterOperator}(${encodeURIComponent(
    `${escapedFilterKey},'${escapedFilterValues}'`
  ).replace(/['()]/g, escape)})`;
};

export const getLogicalExpression = (
  operator: LogicalOperator,
  firstOperand: string,
  secondOperand: string
) => {
  return `${operator}(${firstOperand}${encodeURIComponent(',')}${secondOperand})`;
};
